import React from 'react';
import PropTypes from 'prop-types';
// import tc from 'tinycolor2';
import { get } from 'lodash';
import withData from '@bd/bdcore-data';
import PageHelmet from '@bd/bdcore-pagehelmet';
// import { css } from '@bd/bdui-styles/emotion';
// import { SanitizeHtml } from '@bd/bdcore-utilities';
import PageWrapper from '../../components/PageWrapper';
import InsideHeader from '../../components/InsideHeader';
import ContentBanner from '../../components/ContentBanner';
import LivingMenu from '../../components/menus/Living';
import PhotoList from '../../components/PhotoList';
import CalendarCards from './CalendarCards';
// import { colors, typography } from '../../styles';


function PortAransas({ page }) {
  const welcome = get(page, 'welcome_section[0]');
  return (
    <PageWrapper >
      <PageHelmet page={page} />
      <InsideHeader
        title={`${page.meta.name}`}
        postTitle={get(page, 'page_subtitle')}
        background={get(page, 'page_image.contentUrl')}
      />
      <LivingMenu />
      {
        get(welcome, 'title') && get(welcome, 'lead_copy') &&
        <ContentBanner
          title={get(welcome, 'title')}
          lead={get(welcome, 'lead_copy')}
          image={get(welcome, 'image.contentUrl')}
          video={get(welcome, 'video')}
        />
      }
      <CalendarCards page={get(page, 'port_aransas_event_calendar', [])} />
      {
        get(page, 'photo_gallery', []).length > 0 &&
        <div className="container">
          <PhotoList photos={get(page, 'photo_gallery', [])} />
        </div>
      }
    </PageWrapper>
  );
}

PortAransas.propTypes = {
  page: PropTypes.object.isRequired,
};

export default withData({
  page: 'port_aransas_calendar',
})(PortAransas);



// WEBPACK FOOTER //
// ./src/pages/PortAransas/index.js